export default "__VITE_ASSET__BOHBV9qq__"